(function($) {$(document).ready(function() {

	$('.side-campuses__title').on('click', toggleMobileColumn);

	function toggleMobileColumn(event) {
		if (window.innerWidth >= 1200) return;
		
		const $this = $(this);

		$this
			.closest('.side-campuses__item')
			.toggleClass('open')
			.find('.side-campuses__main')
			.slideToggle();

		$this
			.siblings('.side-campuses__thumb')
			.slideToggle();
	}

});;jQueryBridget("flickity", Flickity, $);})(window.NEW_jquery);